import { Injectable } from '@angular/core';
import { IAPIFilterOption } from '@sondermind/utilities/models-http';
import { IInsuranceOptionValue, NoInsuranceOptionValue } from '@sondermind/utilities/models-provider-network-company';

import { IFilterFormValues } from '../models/filter-form.interface';
import { IConcernOptionValue } from '../models/specialty';

@Injectable({
  providedIn: 'root'
})
export class OutgoingFilterConversionService {
  formFiltersToApiFilterValues(incomingFilters: IFilterFormValues): IAPIFilterOption[] {
    let result: IAPIFilterOption[] = [];

    if (incomingFilters.concerns != null) {
      result = result.concat(this.processConcerns(incomingFilters.concerns));
    }

    if (incomingFilters.genders != null) {
      result.push({
        key: 'genders',
        value: incomingFilters.genders.join(',')
      });
    }

    if (incomingFilters.insurance) {
      if (this.parseInsuranceValue(incomingFilters.insurance)) {
        result.push({
          key: 'provider_network_company_id',
          value: incomingFilters.insurance.pncId.toString()
        });
      }
    }

    if (incomingFilters.state) {
      result.push({
        key: 'practice_state',
        value: incomingFilters.state
      });
    }

    return result;
  }

  processConcerns(incomingConcerns: IConcernOptionValue[]): IAPIFilterOption[] {
    const result: IAPIFilterOption[] = [];

    const specialties: number[] = [];
    const modalities: number[] = [];
    incomingConcerns.forEach((concern: IConcernOptionValue) => {
      if (concern.isPsychiatrist) {
        result.push({
          key: 'is_psychiatrist',
          value: 'true'
        });
        return;
      }
      if (concern.isModality) {
        modalities.push(concern.id);
      } else {
        specialties.push(concern.id);
      }
    });

    if (specialties.length > 0){
      result.push({
        key: 'specialties',
        value: specialties.join(',')
      });
    }

    if (modalities.length > 0){
      result.push({
        key: 'modalities',
        value: modalities.join(',')
      });
    }

    return result;
  }

  parseInsuranceValue(insurance: IInsuranceOptionValue): IInsuranceOptionValue | null {
    const isValidNonCashSelection = insurance.pncId !== NoInsuranceOptionValue.NOT_SURE
      && insurance.pncId !== NoInsuranceOptionValue.CASH_PAY;

    return isValidNonCashSelection ? insurance : null;
  }
}
